module.exports = __webpack_public_path__ + "img/04.670dc7b7.jpg";